function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var MozambiqueFlag = props => /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {}, {
  children: [/*#__PURE__*/_jsx("mask", {
    id: "mask0_621_2311",
    style: {
      maskType: 'luminance'
    },
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "3",
    width: "24",
    height: "18",
    children: /*#__PURE__*/_jsx("rect", {
      y: "3",
      width: "24",
      height: "18",
      fill: "white"
    })
  }), /*#__PURE__*/_jsxs("g", {
    mask: "url(#mask0_621_2311)",
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 3V21H24V3H0Z",
      fill: "#F7FCFF"
    }), /*#__PURE__*/_jsx("mask", {
      id: "mask1_621_2311",
      style: {
        maskType: 'luminance'
      },
      maskUnits: "userSpaceOnUse",
      x: "0",
      y: "3",
      width: "24",
      height: "18",
      children: /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 3V21H24V3H0Z",
        fill: "white"
      })
    }), /*#__PURE__*/_jsxs("g", {
      mask: "url(#mask1_621_2311)",
      children: [/*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 3V9H24V3H0Z",
        fill: "#FECA00"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 15V21H24V15H0Z",
        fill: "#009933"
      }), /*#__PURE__*/_jsx("path", {
        d: "M0 8.5H-0.5V9V15V15.5H0H24H24.5V15V9V8.5H24H0Z",
        fill: "#272727",
        stroke: "white"
      })]
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 3V21L13.5 12L0 3Z",
      fill: "#F50100"
    }), /*#__PURE__*/_jsx("mask", {
      id: "mask2_621_2311",
      style: {
        maskType: 'luminance'
      },
      maskUnits: "userSpaceOnUse",
      x: "0",
      y: "3",
      width: "14",
      height: "18",
      children: /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 3V21L13.5 12L0 3Z",
        fill: "white"
      })
    }), /*#__PURE__*/_jsxs("g", {
      mask: "url(#mask2_621_2311)",
      children: [/*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.05161 13.7649L3.21741 16.0528L4.51744 12.9953L2.28363 10.8441H4.92033L6.00227 8.25L7.15141 10.8441H9.78363L7.43182 12.9953L8.60883 16.0528L6.05161 13.7649Z",
        fill: "#FECA00"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M4.61703 11.9882L4.13635 13.5935C4.13635 13.5935 5.75908 13.5775 5.95398 13.7414C6.54123 13.3752 7.7502 13.5935 7.7502 13.5935L7.10717 11.8755C7.10717 11.8755 6.29188 11.506 5.95398 11.7086C5.12577 11.5215 4.61703 11.9882 4.61703 11.9882Z",
        fill: "#F7FCFF"
      }), /*#__PURE__*/_jsx("path", {
        d: "M8.67282 14.4122C8.7974 14.5777 8.76427 14.8128 8.59882 14.9374C8.43338 15.0619 8.19826 15.0288 8.07368 14.8634L4.93861 10.6999C4.81403 10.5345 4.84716 10.2994 5.01261 10.1748C5.17805 10.0502 5.41317 10.0833 5.53775 10.2488L8.67282 14.4122Z",
        fill: "#212124"
      }), /*#__PURE__*/_jsx("path", {
        d: "M5.23054 10.3798L4.93054 10.0198",
        stroke: "#212124",
        strokeWidth: "0.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M4.2035 10.0219L3.29712 11.4734L3.75031 12.2584L4.78694 10.7178L4.9734 10.2414L4.78694 10.0219H4.2035Z",
        fill: "#212124"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3.02924 14.3314L3.72584 15.1403L8.99713 9.03224L6.60106 10.526L3.02924 14.3314Z",
        fill: "#212124"
      })]
    })]
  })]
}));
//# sourceMappingURL=Mozambique.js.map